import { CONNECTIVITY_STATUS_CHANGED } from './constants';
import { createCustomAction } from 'typesafe-actions';

export const changeOnline = createCustomAction(CONNECTIVITY_STATUS_CHANGED, (type) => (online: boolean) => ({
    type,
    payload: {
        online,
    },
}));
